import { Directive, HostListener } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[integerInput]',
  standalone: true,
})
export class IntegerInputDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement
    const formatted = this.formatInteger(input.value)
    this.ngControl.control?.setValue(formatted, { emitEvent: false })
  }

  private formatInteger(value: string): string {
    // Remove tudo que não for número
    const onlyNumbers = value.replace(/\D/g, '')

    // Evita formatação se o campo estiver vazio
    if (!onlyNumbers) return ''

    // Formata com separadores de milhar no padrão pt-BR
    return parseInt(onlyNumbers, 10).toLocaleString('pt-BR')
  }
}
